export default __webpack_public_path__ + "static/media/download.5229ceb3.svg";